export function createHttpHeaders(includeAuth: boolean = true, token?: string): Record<string, string> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  // Adicionar Ocp-Apim-Subscription-Key apenas em ambientes NÃO produção (DEV/QAS)
  if (process.env.REACT_APP_ENVIRONMENT !== 'production' && process.env.REACT_APP_OCP_APIM_KEY) {
    headers["Ocp-Apim-Subscription-Key"] = process.env.REACT_APP_OCP_APIM_KEY;
  }

  // Adicionar authorization se solicitado
  if (includeAuth && token) {
    headers["authorization"] = `Bearer ${token}`;
  }

  return headers;
}

/**
 * Verifica se está em ambiente de produção
 */
export function isProduction(): boolean {
  return process.env.REACT_APP_ENVIRONMENT === 'production';
}

/**
 * Obtém a chave APIM apenas se NÃO estiver em produção (DEV/QAS)
 */
export function getApimKey(): string | undefined {
  return !isProduction() ? process.env.REACT_APP_OCP_APIM_KEY : undefined;
}
